// FULL UPDATED CODE — TOTAL PRICE BLACK + SEARCH BELOW BOUQUET PACK

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  CssBaseline,
  Container,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Button,
  IconButton,
  TextField,
  InputAdornment,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
} from "@mui/material";

import { ArrowBack as ArrowBackIcon, Close as CloseIcon } from "@mui/icons-material";
import AuthApi4 from "../services/authApi";
import Navbar from "../sidebar/SideNavbar";
import Footer from "../sidebar/Footer";
import Swal from 'sweetalert2';

export default function AddChannel() {

  const location = useLocation();
  const { stbId } = location.state || {};
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState('bouquetChannel');
  const [section1Items, setSection1Items] = useState([]);
  const [section2Items, setSection2Items] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [planD, setPlanD] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');

  const totalPrice = planD.reduce((sum, subscription) => {
    return sum + (subscription.subs_grnd_tot_prc || 0);
  }, 0);

  useEffect(() => {
    fetchBouquet();
  }, []);

  const addChannel = useCallback(async (section) => {
    if (section === 'bouquetChannel') {
      fetchBouquet();
    } else {
      fetchPayChannel();
    }
  }, []);

  const fetchBouquet = useCallback(async () => {
    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          stbId: stbId,
          genre: "A",
          type: "addChnl"
        },
      ],
    };

    await AuthApi4.addChannels(data)
      .then((response) => {
        setSection2Items(response.data.packDetails);
      })
      .catch((e) => {
        console.log("API Error", e);
      });
  }, [stbId]);

  const fetchPayChannel = useCallback(async () => {
    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          stbId: stbId,
          genre: "C",
          type: "addChnl"
        },
      ],
    };

    await AuthApi4.addChannels(data)
      .then((response) => {
        setSection1Items(response.data.packDetails);
      })
      .catch((e) => {
        console.log("API Error", e);
      });
  }, [stbId]);

  const packInfo = useCallback(async () => {
    if (selectedItems.length === 0) {
      setPlanD([]);
      return;
    }

    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          subs_id: selectedItems,
          type: "packInfo"
        },
      ],
    };

    await AuthApi4.addChannels(data)
      .then((response) => {
        setPlanD(response.data.packDetails);
      })
      .catch((e) => {
        console.log("API Error", e);
      });
  }, [selectedItems]);

  useEffect(() => {
    packInfo();
  }, [selectedItems]);

  const handleCheckboxChange = (subs_id) => {
    setSelectedItems((prev) =>
      prev.includes(subs_id)
        ? prev.filter((id) => id !== subs_id)
        : [...prev, subs_id]
    );
  };

  const handleSectionClick = (section) => {
    setActiveSection(section);
    addChannel(section);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          stbId: stbId,
          genre: activeSection === 'bouquetChannel' ? 'A' : 'C',
          subs_name: value,
          type: "packFilter"
        },
      ],
    };

    await AuthApi4.addChannels(data)
      .then((response) => {
        activeSection === 'bouquetChannel'
          ? setSection2Items(response.data.packDetails)
          : setSection1Items(response.data.packDetails);
      })
      .catch((e) => console.log("Search Error", e));
  };

  const clearSearch = () => {
    setSearchTerm('');
    addChannel(activeSection);
  };

  const handleAddChannelBtn = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to Add Channels?",
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    if (selectedItems.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Packs Not Selected',
        text: 'Please select a pack before proceeding.'
      });
      return;
    }

    setLoading(true);

    let data1 = {
      records: [
        { CUST_ID: localStorage.getItem("payment_cust_num"), type: "wallet" }
      ]
    };

    await AuthApi4.stbinfo(data1)
      .then(async (response) => {

        if (response.data.stbdetails[0].bill_total < totalPrice) {
          setLoading(false);
          Swal.fire({ icon: 'error', title: 'Insufficient Amount' });
          return;
        }

        let data = {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          stb_id: stbId,
          subs_ids: selectedItems.map((i) => ({ subs_id: i })),
          type: "addChnls"
        };

        await AuthApi4.stbAddChannel(data)
          .then((res) => {
            setLoading(false);
            if (res.data.add_c[0].p_out_mssg_flg === 'S') {
              Swal.fire({ icon: 'success', title: 'Added Successfully' }).then(() => {
                navigate("/subscriptionM");
              });
            } else {
              Swal.fire({ icon: 'error', title: 'Failed', text: res.data.p_out_mssg });
            }
          });

      })
      .catch((e) => console.log("Wallet Err", e));
  };

  return (
    <div style={{ display: "flex", background: "#F5F5F5" }}>
      <CssBaseline />
      <Navbar />

      <main style={{ flexGrow: 1, padding: '5px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingTop: 10 }}>
          <Typography variant="h5">Add Channels</Typography>
          <IconButton
            onClick={() => navigate("/subscriptionM")}
            sx={{
              backgroundColor: '#ff8c00',
              color: '#fff',
              '&:hover': { backgroundColor: '#ffad42' },
            }}
          >
            <ArrowBackIcon /> Back
          </IconButton>
        </Box>

        <Container sx={{ minHeight: '100vh' }}>
          <Paper sx={{ padding: 2 }}>

            {/* TOP SECTION BUTTONS */}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Card
                  onClick={() => handleSectionClick('bouquetChannel')}
                  sx={{
                    backgroundColor: activeSection === 'bouquetChannel' ? '#ff8c00' : '#fff',
                    color: activeSection === 'bouquetChannel' ? '#fff' : '#000',
                    cursor: 'pointer',
                    textAlign: 'center'
                  }}
                >
                  <CardContent><Typography>Bouquet Packs</Typography></CardContent>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card
                  onClick={() => handleSectionClick('payChannel')}
                  sx={{
                    backgroundColor: activeSection === 'payChannel' ? '#ff8c00' : '#fff',
                    color: activeSection === 'payChannel' ? '#fff' : '#000',
                    cursor: 'pointer',
                    textAlign: 'center'
                  }}
                >
                  <CardContent><Typography>Pay Channels</Typography></CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* SEARCH BOX — NOW BELOW PACK BUTTONS */}
           <Box
  sx={{
    marginTop: 2,
    marginBottom: 2,
    display: "flex",
    justifyContent: "flex-start",
  }}
>
  <TextField
    variant="outlined"
    size="small"
    label="Search by Pack Name"
    value={searchTerm}
    onChange={handleSearchChange}
    sx={{ width: "500px" }}   
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          {searchTerm !== "" && (
            <IconButton onClick={clearSearch} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </InputAdornment>
      ),
    }}
  />
</Box>


            {/* PACK LIST + SELECTED PACK LIST */}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box sx={{ height: 200, overflowY: 'auto', border: '1px solid black', padding: 1 }}>
                  <FormGroup>
                    {(activeSection === 'payChannel' ? section1Items : section2Items).map((item, idx) => (
                      <FormControlLabel
                        key={idx}
                        control={
                          <Checkbox
                            checked={selectedItems.includes(item.subs_id)}
                            onChange={() => handleCheckboxChange(item.subs_id)}
                          />
                        }
                        label={item.sub_name}
                      />
                    ))}
                  </FormGroup>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <TableContainer component={Paper} sx={{ height: 200, overflowY: 'auto', border: '1px solid black' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>SI No</TableCell>
                        <TableCell>Prod ID</TableCell>
                        <TableCell>Pack Name</TableCell>
                        <TableCell>Price</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {planD.length > 0 ? (
                        planD.map((row, idx) => (
                          <TableRow key={idx}>
                            <TableCell>{idx + 1}</TableCell>
                            <TableCell>{row.prod_id}</TableCell>
                            <TableCell>{row.subs_desc}</TableCell>
                            <TableCell>{row.subs_grnd_tot_prc}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align="center">No Data</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>

            {/* FOOTER */}
            <Box sx={{
              marginTop: 3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderTop: '1px solid #ddd',
              paddingTop: 2
            }}>

              {/* TOTAL PRICE — NOW BLACK */}
              <Typography variant="h6" sx={{ color: '#000', fontWeight: 'bold' }}>
                Total Price: ₹ {totalPrice.toFixed(2)}
              </Typography>

              <Box>
                <Button
                  variant="outlined"
                  sx={{ color: '#ff8c00', borderColor: '#ff8c00', marginRight: 2 }}
                  onClick={() => window.location.reload()}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  sx={{ backgroundColor: '#ff8c00' }}
                  onClick={handleAddChannelBtn}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : "Add"}
                </Button>
              </Box>

            </Box>

          </Paper>
        </Container>

        <Footer />
      </main>
    </div>
  );
}
